<nav class="navbar navbar-expand-lg" [ngStyle]="{'background':bgColor}">
  <div class="container">
    <a class="navbar-brand" href="#">
      <img src="../../../../assets/img/logo/logo-white.png" alt="" loading="lazy">
    </a>
    <button #navbarToggler class="navbar-toggler text-white" (click)="changeColor()" type="button"
      data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02"
      aria-expanded="false" aria-label="Toggle navigation">
      <i class="material-icons">
        menu
      </i>
    </button>

    <div class="collapse {{show}} navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav mt-2 mt-lg-0">
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link" (click)="collapseNav()" [routerLink]="['/']">{{'header.home' | translate}}</a>
        </li>
        <li class="nav-item dropdown" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link dropdown-toggle" data-toggle="dropdown" [routerLink]="['/nosotros']" role="button"
            aria-haspopup="true" aria-expanded="false">{{'header.about' | translate}}</a>
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="collapseNav()"
              [routerLink]="['/nosotros/sobre-nosotros']">{{'header.about_us' | translate}}</a>
            <a class="dropdown-item" (click)="collapseNav()"
              [routerLink]="['/nosotros/nuestro-equipo']">{{'header.our_team' | translate}}</a>
          </div>
        </li>
        
        <li class="nav-item dropdown" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a [routerLink]="['/solucion']" id="menu" data-toggle="dropdown" class="nav-link dropdown-toggle"
            data-display="static">{{'header.solution' | translate}}</a>
          <ul class="dropdown-menu">
            <li class="dropdown-item dropdown-submenu">
              <a  [routerLink]="['/solucion/ambiental']" data-toggle="dropdown">{{'header.environment' | translate}}</a>              
            </li>
            <li class="dropdown-item dropdown-submenu show">
              <a [routerLink]="['/solucion/industrial']" data-toggle="dropdown" class="dropdown-toggle" aria-expanded="true">{{'header.industrial' | translate}}</a>
              <ul class="dropdown-menu show">
                <li class="dropdown-item">
                  <a [routerLink]="['/solucion/industrial/emesent']" >Servicio de Escaneo Lidar</a>
                </li>
                <!-- <li class="dropdown-item">
                  <a [routerLink]="['/solucion/industrial/rawview']" >Servicio para Almacenes</a>
                </li>                 -->
              </ul>
            </li>
          </ul>
        </li>
        <!-- <li class="nav-item dropdown" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link dropdown-toggle" data-toggle="dropdown" [routerLink]="['/aplicaciones']" role="button"
            aria-haspopup="true" aria-expanded="false">{{'header.applications' | translate}}</a>
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="collapseNav()"
              [routerLink]="['/aplicaciones/qhawax-modules']">{{'header.qhawax_modules' | translate}}</a>                        
            <a class="dropdown-item" (click)="collapseNav()"
              [routerLink]="['/aplicaciones/venta-drones']">{{'header.drones_sales' | translate}}</a>
            <a class="dropdown-item" (click)="collapseNav()"
              [routerLink]="['/aplicaciones/cursos-drones']">{{'header.drones_courses' | translate}}</a>
          </div>
        </li> -->
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link" (click)="collapseNav()" [routerLink]="['/reportes']">{{'header.blog' | translate}}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link" (click)="collapseNav()" [routerLink]="['/proyectos']">{{'header.projects' |
            translate}}</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link" (click)="collapseNav()" [routerLink]="['/contacto']">{{'app.contact_us' | translate}}</a>
        </li>
        <li class="dropdown nav-item">
          <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
            aria-expanded="false">
            {{language | uppercase}}
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="changeLanguageToSpanish()">{{'header.spanish' | translate}}</a>
            <a class="dropdown-item" (click)="changeLanguageToEnglish()">{{'header.english' | translate}}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>